import { makeStyles } from '@material-ui/core/styles';

const useStyle = makeStyles((theme) => ({
  editIcon: {
    color: theme.palette.grey[700],
  },
}));

export default useStyle;
